import { Component, Input, OnDestroy, OnInit, } from '@angular/core';
import { ContaBancariaService } from 'administrativo-lib';
import { TransferenciaAutorizacaoService } from 'contabil-lib';
import { ContaBancaria, EddyAutoComplete, FuncaoService, LoginContabil, TransferenciaAutorizacao } from 'eddydata-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as toastr from 'toastr';

declare var $: any

@Component({
  selector: 'app-transferencia-redistribuicao-recurso-dlg',
  templateUrl: './transferencia-redistribuicao-recurso-dlg.component.html'
})
export class TransferenciaRedistribuicaoRecursoDlgComponent implements OnInit, OnDestroy {

  /**
   * Declaração de variáveis
   */
  @Input() login: LoginContabil;

  public pagadoraAutoComplete: EddyAutoComplete<ContaBancaria>;
  public contaPagadora: ContaBancaria;
  private unsubscribe: Subject<void> = new Subject();
  public data: Date;
  public grupoRecebimentos: Array<any>;
  public expandedGroups: { [key: number]: boolean } = {}; // Pode ser ID ou índice


  /**
   * Construtor com as injeções de dependencias
   */
  constructor(
    private contaService: ContaBancariaService,
    private transferenciaAutorizacaoService: TransferenciaAutorizacaoService,
    private funcaoService: FuncaoService,
  ) { }

  ngOnInit(): void {
    this.pagadoraAutoComplete = new EddyAutoComplete(null, this.contaService,
      'codigo', ['numero_conta', 'banco.nome', 'nome'],
      { orgao_id: this.login.orgao.id, orderBy: 'nome', ativo: true, relations: 'orgao,banco,recursos.recurso,recursos.aplicacao,recursos.convenio' },
      { number: ['codigo'], text: ['numero_conta', 'nome'] },
      () => this.buscarRecebimentos(),
    );

    this.data = new Date();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  // ========================================================================
  //                            MÉTODOS DA CLASSE
  // ========================================================================
  private buscarRecebimentos() {
    this.transferenciaAutorizacaoService.filtrar(1, -1, {
      'conta_recebedora.id': this.contaPagadora.id,
      'exercicio.id': this.login.exercicio.id,
      'orgao.id': this.login.orgao.id,
      'data_transfere': this.funcaoService.converteDataSQL(this.data),
      'redistribuicao_efetuada': false,
      'relations': 'recebimentos.ficha.aplicacao_variavel,recebimentos.ficha.receita'
    }).pipe(takeUntil(this.unsubscribe))
      .subscribe(async res => {
        if (res.numberOfElements === 0) {
          toastr.warning(`Não foram localizados nenhum recebimento transferido para a conta: ${this.contaPagadora.numero_conta} - ${this.contaPagadora.digito_conta} no dia ${this.funcaoService.converteDataBR(this.data)}`);
          return;
        }
        let recebimentos = [];
        res.content
          .forEach((item: TransferenciaAutorizacao) => (recebimentos = recebimentos.concat(item.recebimentos.map(receita => ({ ...receita, autorizacao_id: item.id })))));

        recebimentos
          .sort((a, b) => Number(a.ficha.aplicacao_variavel.codigo) - Number(b.ficha.aplicacao_variavel.codigo));

        recebimentos = this.funcaoService
          .agrupar(
            recebimentos,
            ['ficha.aplicacao_variavel.codigo', 'ficha.aplicacao_variavel.nome', 'ficha.aplicacao_variavel.id'],
            ['valor_recebido']
          );

        for (const item of recebimentos) {
          const contaBancaria = await this.contaService.filtrar(1, 1, {
            'recursos.recurso_pagto': true,
            'recursos.convenio.id': item['grupo']['ficha.aplicacao_variavel.id'],
            'ativo': true,
            'orgao.id': this.login.orgao.id,
            'ignoreCondObrig': true
          }).toPromise();

          if (contaBancaria.numberOfElements === 0) {
            toastr.warning(`Não foi localizado conta bancária para o seguinte recurso: ${item['grupo']['ficha.aplicacao_variavel.codigo']} - ${item['grupo']['ficha.aplicacao_variavel.nome']}<br>Transferência Origem: ${item['registros'][0]['autorizacao_id']}`);
            return;
          }

          item['grupo']['conta'] = contaBancaria.content[0];
          item['grupo']['transferencia_origem'] = res.content.map(transferencia => transferencia.id).join()
        }

        this.grupoRecebimentos = recebimentos;

        this.grupoRecebimentos.forEach((_, index) => {
          this.expandedGroups[index] = true;
        });
      })
  }


  public gerarTransferencias() {
    const transferencias: Array<TransferenciaAutorizacao> = this.grupoRecebimentos.map(item => {
      return {
        data_transfere: this.data,
        mes: +this.funcaoService.converteDataSQL(this.data).split('-')[1],
        documento: 'TRANSFERÊNCIA',
        tipo: '1',
        finalidade: 0,
        historico: 'TRANSFERÊNCIA BANCÁRIA',
        valor_transferido: +item.totalizadores.valor_recebido,
        conta_recebedora: item.grupo.conta,
        conta_pagadora: this.contaPagadora,
        exercicio: this.login.exercicio,
        orgao: this.login.orgao,
        convenio_correto: item.grupo['ficha.aplicacao_variavel.id'],
      }
    });

    const transferenciasOrigem = this.grupoRecebimentos[0].grupo.transferencia_origem;

    this.transferenciaAutorizacaoService.salvarDistribuicoesFonteRecurso(transferencias, transferenciasOrigem)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        toastr.success('Distribuição por fontes de recurso realizada com sucesso')
        this.grupoRecebimentos = [];
        this.contaPagadora = null;
        $('#transferenciaRedistribuicao').modal('hide');
      })
  }
}